import {useGlobalFilter, usePagination, useTable} from "react-table";
import {
    CSM_ADD_INSTITUTION_PATH,
    CSM_INSTITUTION_TABLE_ACCESS_LEVEL_HEADER,
    CSM_INSTITUTION_TABLE_DOMAIN_HEADER,
    CSM_INSTITUTION_TABLE_NAME_HEADER,
    EDIT_TEXT,
    PPT_POLLS_TABLE_ACTION_HEADER,
    TYPE,
} from "../../utils/constants";
import classes from "./InstitutionManagementPage.module.css";
import React, {Fragment, useEffect, useState} from "react";
import {Table} from "react-bootstrap";
import { ReactComponent as EditIcon } from "../../images/pencil.svg";
import {ReactComponent as NoResultImage} from "../../images/no-result-found.svg";
import NormalPagination from "../../components/pagination/NormalPagination";
import {AuthenticationApiCalls} from "../../apis/AuthenticationApiCalls";
import {useLoading} from "../../utils/LoadingContext";
import {useHistory} from "react-router-dom";
import {useConfig} from "../../hooks/useConfig";
import TableSortHeaderNew from "../../components/TableSortHeaderNew";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";



export default function InstitutionManagementTable({columns, data, setData, globalFilterObj, reload}) {
    let history = useHistory();
    const { loading, setLoading } = useLoading();
    const {switchInst} = AuthenticationApiCalls();
    let config = useConfig();
    const [sortedBy, setSortedBy] = useState("");


    const filterCustomize = (rows, _, globalFilterValue) => {
        if (Object.entries(globalFilterValue).length === 0) {
            return rows;
        }

        const filteredKeyword = globalFilterValue.keyword ? globalFilterValue.keyword.toLowerCase().trim() : "";

        return rows.filter(r => {
            if (!filteredKeyword) {
                return true;
            }
            const values = r.values;
            if (!!values.fullName && values.fullName.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            if (!!values.domain && values.domain.toLowerCase().indexOf(filteredKeyword) > -1) {
                return true;
            }

            return false;
        });
    };

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex},
        setGlobalFilter,
    } = useTable({
        columns,
        data,
        initialState: { pageIndex: 0, pageSize: 8},
        autoResetPage: true,
        globalFilter: filterCustomize,
    }, useGlobalFilter, usePagination);

    useEffect(() => {
        setGlobalFilter(globalFilterObj);
    }, [data, globalFilterObj]);


    const SORTABLE_HEADER = [
        CSM_INSTITUTION_TABLE_NAME_HEADER,
        // CSM_INSTITUTION_TABLE_SHORT_NAME_HEADER,
        CSM_INSTITUTION_TABLE_DOMAIN_HEADER,
        TYPE,
        CSM_INSTITUTION_TABLE_ACCESS_LEVEL_HEADER
    ];

    if (!page || !page.length) {
        return (
            <div className={classes.tableContainerCard}>
                <NoResultImage style={{height: 150, alignSelf: "center", margin: "20px 0"}}/>
                <span style={{alignSelf: "center", fontSize: 20, fontWeight: "600", lineHeight: 1.4}}>
                    No Institutions found
                </span>
                <span style={{alignSelf: "center"}}>
                    Try broadening your search criteria to find what you are looking for or asking CSM Admin to manage the institution access.
                </span>
            </div>
        );
    }



    return (
        <>
            <div className={classes.tableContainerCard}>
                <div className={classes.tableWrapper}>
                    <Table hover {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup, index) => (
                                <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map((column, idx) => (
                                        <Fragment key={idx}>
                                            {SORTABLE_HEADER.includes(column.Header) &&
                                                <TableSortHeaderNew
                                                    data={data}
                                                    setData={setData}
                                                    sortedBy={sortedBy}
                                                    setSortedBy={setSortedBy}
                                                    propertyName={column.id}
                                                    label={column.render('Header')}
                                                    {...column.getHeaderProps({
                                                        style: {
                                                            width: column.width,
                                                            minWidth: column.minWidth,
                                                            textAlign: 'left',
                                                            paddingLeft: column.Header === CSM_INSTITUTION_TABLE_NAME_HEADER
                                                                ? 20 : undefined
                                                        }
                                                    })}
                                                >
                                                    {column.render('Header')}
                                                </TableSortHeaderNew>
                                            }

                                            {column.render('Header') === PPT_POLLS_TABLE_ACTION_HEADER &&
                                                <th
                                                    {...column.getHeaderProps({
                                                        style: {
                                                            width: column.width,
                                                            minWidth: column.minWidth,
                                                            textAlign: 'center'
                                                        }
                                                    })}
                                                >
                                                    <span>
                                                        {column.render('Header')}
                                                    </span>
                                                </th>
                                            }

                                        </Fragment>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr
                                        key={index}
                                        tabIndex={0}
                                        {...row.getRowProps()}
                                        style={{
                                            cursor: "pointer"
                                        }}
                                        onClick={() => {
                                            if (loading) {
                                                return;
                                            }

                                            if (!row.original.domain) {
                                                return;
                                            }

                                            setLoading(true);
                                            switchInst(row.original.shortName).then((secret) => {
                                                if(!!secret) {
                                                    window.location.href =
                                                        `https://${row.original.shortName}.${config.host_url}/csm/redirect?secret=${secret}&to=/home`;
                                                } else {
                                                    reload();
                                                }
                                            }).finally(() => {
                                                setLoading(false);
                                            });
                                        }}
                                    >
                                        {row.cells.map((cell, cellIdx) => {
                                            if (cell.column.Header === PPT_POLLS_TABLE_ACTION_HEADER) {
                                                return (
                                                    <td key={cellIdx} width={80}>
                                                        <span style={{ display: "flex", justifyContent: "center" }} >
                                                            <YuJaKebabMenuNew>
                                                                <YuJaKebabMenuNew.Menu>
                                                                    <YuJaKebabMenuNew.Item
                                                                        onClick={() => history.push(CSM_ADD_INSTITUTION_PATH + "/" + row.original.institutionId)}
                                                                    >
                                                                        <EditIcon />{EDIT_TEXT}
                                                                    </YuJaKebabMenuNew.Item>
                                                                </YuJaKebabMenuNew.Menu>
                                                            </YuJaKebabMenuNew>
                                                        </span>
                                                    </td>
                                                )
                                            } else if (cell.column.Header === CSM_INSTITUTION_TABLE_DOMAIN_HEADER) {
                                                return (
                                                    <td key={cellIdx}>
                                                        <div className={classes.row} style={{width: "100%"}}>
                                                            <span
                                                                style={{
                                                                    flex: "0 1 auto",
                                                                    minWidth: 0,
                                                                    textOverflow: "ellipsis",
                                                                    whiteSpace: "nowrap",
                                                                    overflow: "hidden",
                                                                    display: "inline-block",
                                                                }}
                                                                title={!!cell.value ? cell.value : ""}
                                                            >
                                                                {!cell.value ? "-" : cell.value}
                                                            </span>
                                                            {/*{!!cell.value &&*/}
                                                            {/*    (row.original.isDomainValid*/}
                                                            {/*        ? <VALID_DOMAIN style={{marginLeft: 5, flexShrink: 0}}/>*/}
                                                            {/*        : <INVALID_DOMAIN style={{marginLeft: 5, flexShrink: 0}}/>*/}
                                                            {/*    )*/}
                                                            {/*}*/}
                                                        </div>

                                                    </td>
                                                );
                                            } else {
                                                return (
                                                    <td
                                                        key={cellIdx}
                                                        style={{
                                                            paddingLeft: cell.column.Header === CSM_INSTITUTION_TABLE_NAME_HEADER
                                                                ? 20 : undefined
                                                        }}
                                                    >
                                                        <span
                                                            style={{
                                                                textOverflow: "ellipsis",
                                                                whiteSpace: "nowrap",
                                                                overflow: "hidden",
                                                                width: "100%",
                                                                // maxWidth: "100%"
                                                            }}
                                                            title={!!cell.value ? cell.value : ""}
                                                        >
                                                            {
                                                                (cell.column.Header === CSM_INSTITUTION_TABLE_DOMAIN_HEADER && !cell.value) ? "-" : cell.value
                                                            }
                                                        </span>
                                                    </td>
                                                );
                                            }
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </div>
            </div>

            <NormalPagination
                pageCount={pageCount}
                pageIndex={pageIndex}
                pageOptions={pageOptions}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                previousPage={previousPage}
                nextPage={nextPage}
                gotoPage={gotoPage}
                paddingTop="0px"
            />
        </>
    );
}